import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import Button, { ButtonLink } from '@kyruus/button';
import Link from '@kyruus/link';
import ImageComponent from '@kyruus/image-component';

export const MapCardContainer = styled.div`
  border-radius: ${fromTheme('border_radius_medium')};
  border: ${fromTheme('border_width')} ${fromTheme('border_style')}
    ${fromTheme('color_border')};
  overflow: hidden;
  background-color: ${fromTheme('color_background')};
  width: 90%;

  @media only screen and (min-width: ${fromTheme('screen_medium')}) {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: ${fromTheme('spacing_large')} ${fromTheme('spacing_large')};
  }
`;

// ------------------------------------

// ImageSection
export const ImageSection = styled.section`
  position: relative;
  @media only screen and (min-width: ${fromTheme('screen_medium')}) {
    flex: 0 0 33%;
  }
`;

export const LocationImgLink = styled.a`
  display: block;
`;

export const LocationImg = styled(ImageComponent)`
  img {
    display: block;
    width: 100%;
    height: ${({ enableEnhancement }) =>
      enableEnhancement ? 'unset' : '150px'};
    object-fit: cover;
  }
`;

export const SvgButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  border: ${fromTheme('border_width')} ${fromTheme('border_style')}
    ${fromTheme('color_border')};
  color: ${fromTheme('color_text')};
  border-radius: 25px;
  margin: 5px;
  background: ${fromTheme('color_switch_off')};

  > svg {
    padding: 4px;
  }

  &:focus {
    outline: 1px dotted #212121;
    outline: 5px auto Highlight; // Firefox
    outline: 5px auto -webkit-focus-ring-color;
  }

  @media only screen and (min-width: ${fromTheme('screen_medium')}) {
    // Do not show on desktop/ipad
    display: none;
  }
`;

// ------------------------------------

// TextSection
export const TextSection = styled.section`
  position: relative;
  width: 100%;
  padding: ${fromTheme('spacing_small')} ${fromTheme('spacing_medium')};

  @media only screen and (min-width: ${fromTheme('screen_medium')}) {
    flex: 0 0 44%;
    padding: 0 ${fromTheme('spacing_large')};
  }
`;

export const LocationNameHeading = styled.h2`
  font-size: ${fromTheme('font_size_heading_4')};
  font-weight: ${fromTheme('font_weight_bold')};
  color: ${fromTheme('color_providermatch')};
  margin-bottom: ${fromTheme('spacing_small')};
  // account for text overflow into MobilePhone
  margin-right: 40px;

  @media only screen and (min-width: ${fromTheme('screen_medium')}) {
    margin-right: 0;
  }
`;

export const SvgLink = styled(SvgButton.withComponent('a'))`
  color: ${fromTheme('color_link')};
  margin-right: ${fromTheme('spacing_medium')};
  margin-top: ${fromTheme('spacing_small')};
`;

export const LocationType = styled.span`
  font-size: ${fromTheme('font_size')};
  font-weight: ${fromTheme('font_weight_bold')};
  color: ${fromTheme('color_text_secondary')};
  margin-bottom: ${fromTheme('spacing_medium')};
  display: block;
`;

export const Address = styled.span`
  font-size: ${fromTheme('font_size')};
  color: ${fromTheme('color_text')};
  margin-bottom: ${fromTheme('spacing_xsmall')};
  line-height: ${fromTheme('font_line_height')};
`;

export const AccessibiltyInfo = styled.p`
  font-size: ${fromTheme('font_size_small')};
  color: ${fromTheme('color_text_secondary')};
  // adding selectivity to prevent providermatch-consumer.css styles from overriding
  &:last-child {
    margin: ${fromTheme('spacing_small')} 0;
  }
`;

// ------------------------------------

// CTASection
export const CTASection = styled.section`
  width: 100%;
  padding: ${fromTheme('spacing_xsmall')} ${fromTheme('spacing_medium')}
    ${fromTheme('spacing_large')} ${fromTheme('spacing_medium')};

  @media only screen and (min-width: ${fromTheme('screen_medium')}) {
    flex: 0 0 23%;
    padding: 0;

    svg {
      position: relative;
      top: 3px;
    }
  }
`;

export const StyledCTAButton = styled(Button)`
  width: 100%;
  @media only screen and (min-width: ${fromTheme('screen_medium')}) {
    margin-bottom: ${fromTheme('spacing_small')};
  }
`;

export const StyledCTAButtonLink = styled(ButtonLink)`
  width: 100%;
  text-decoration: none;
  box-sizing: border-box;
  text-align: center;
  @media only screen and (min-width: ${fromTheme('screen_medium')}) {
    margin-bottom: ${fromTheme('spacing_small')};
  }
  &:focus,
  &:hover {
    text-decoration: none;
  }
  &:visited {
    color: ${fromTheme('color_text_contrast')};
  }
`;

export const DesktopPhoneWrapper = styled.div`
  display: none;

  @media only screen and (min-width: ${fromTheme('screen_medium')}) {
    display: flex;
    justify-content: ${(props) =>
      props.isLeftAligned ? 'flex-start' : 'flex-end'};
    color: ${fromTheme('color_text')};

    svg {
      margin-top: -${fromTheme('spacing_xsmall')};
    }
  }
`;

export const DesktopPhoneLink = styled(Link)`
  margin-left: ${fromTheme('spacing_small')};
  padding-top: 1px;
`;
